import { ReactElement } from 'react';
import { isMobile } from 'utils/is-mobile';
import { Skeleton } from 'newcomponents/UI/Skeleton';

type TAdditionalStatisticsFilterSkeletonProps = {
  block?: boolean;
};

export const AdditionalStatisticsFilterSkeleton = ({
  block
}: TAdditionalStatisticsFilterSkeletonProps): ReactElement => {
  return (
    <Skeleton.Button
      active
      block={block}
      style={{
        minWidth: 10,
        minHeight: 10,
        height: !isMobile() ? '32px' : '40px',
        margin: block ? '8px' : 0,
        borderRadius: 6
      }}
    />
  );
};
